import { render, staticRenderFns } from "./ContentTemplate.vue?vue&type=template&id=bf2e264e&scoped=true&"
import script from "./ContentTemplate.vue?vue&type=script&lang=js&"
export * from "./ContentTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ContentTemplate.vue?vue&type=style&index=0&id=bf2e264e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2e264e",
  null
  
)

export default component.exports